import { render, staticRenderFns } from "./ProductsFileLoader.vue?vue&type=template&id=0f891249&"
import script from "./ProductsFileLoader.vue?vue&type=script&lang=js&"
export * from "./ProductsFileLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports